export default class ServiceTypeRequestUrEntity{
    rushRequest: boolean;
    reasonForReferral: string;
    specialInstructions: string;
    referralId: number;
    utilizationReviewDetailId: number;
}